export type MediaImage = {
  id?: number
  name: string
  original_src: string
  cropped_src: string
  original_path?: string
  cropped_path?: string
  encoded_original_src?: string
  encoded_cropped_src?: string
  cropped_src_md?: string
  encoded_cropped_src_md?: string
  cropped_src_sm?: string
  encoded_cropped_src_sm?: string
  cropped_src_xs?: string
  encoded_cropped_src_xs?: string
  cropped_src_lg?: string
  encoded_cropped_src_lg?: string
}

export type ChangedFileName = {
  newName: string
  index: number
}

export type Gallery = {
  src: string
  name: string
  cropperId: string
}

export type UploadFile = {
  name?: string
  file: File
  has_conversions?: 0 | 1
  organization_id?: number
  user_id?: number
  persona_id?: number
  event_id?: number | null
  type?: UploadTypeEnum
}

export type FileResponse = {
  id: number
  name: string
  path: string
  url: string
  lg_path?: string
  md_path?: string
  sm_path?: string
  xs_path?: string
  lg?: string
  md?: string
  sm?: string
  xs?: string
}

export type FileRequest = {
  id?: number
  name: string
  original_path?: string
  cropped_path?: string
  lg_path?: string
  md_path?: string
  xs_path?: string
  sm_path?: string
}

export enum UploadTypeEnum {
  USER = 'USER',
  ORGANIZATION = 'ORGANIZATION',
  EVENT = 'EVENT'
}
